import { giphyBlack, giphyBlue, giphyCharcoal, giphyLightGrey, giphyWhite, giphyLightCharcoal } from '@giphy/js-brand'
import React, { useContext } from 'react'
import ModalContext from 'shared/components/context/modal'
import { IChannel } from 'shared/types/channel'
import styled, { css } from 'styled-components'
import { AddToCollectionContext } from './context'
import { CollectionContext } from '..'
import { getChannelDepth, MAX_DEPTH } from '../util'

const itemCss = css`
    display: flex;
    justify-content: space-between;
    padding: 12px 27px;
    cursor: pointer;
    user-select: none;
`

export const ExpandToDrop = styled.div`
    ${itemCss}
`

const ActionItem = styled.div<{ isDisabled: boolean }>`
    ${props =>
        props.isDisabled &&
        css`
            pointer-events: none;
        `}
    ${itemCss}
    color: ${giphyCharcoal};
    &:hover { 
        color: ${giphyWhite};
    }
`
const LoadingItem = styled.div`
    ${itemCss}
    color: ${giphyLightCharcoal};
`
const Item = styled.div<{ isActive: boolean }>`
    ${itemCss}
    ${props =>
        props.isActive
            ? props.theme.isSingleColumn
                ? css`
                      color: ${giphyBlue};
                      font-weight: bold;
                  `
                : css`
                      /* active item */
                      background: ${giphyBlue};
                      color: ${giphyBlack};
                      font-weight: bold;
                  `
            : css`
                  /* not active, but maybe a back button */
                  color: ${props.theme.isSingleColumn ? giphyLightGrey : giphyWhite};

                  ${props.theme.isSingleColumn &&
                      css`
                          .ss-navigateright {
                              color: ${giphyWhite};
                          }
                      `}
              `}
`
type Props = {
    channel: IChannel
    isDragging?: boolean
    isDisabled?: boolean
}

export const LoaderListItem = () => {
    return <LoadingItem>Loading...</LoadingItem>
}

const ChannelListItem = ({ channel, isDragging }: Props) => {
    const { activeChannelId, setActiveChannelId } = useContext(AddToCollectionContext)
    const isActive = isDragging || activeChannelId === channel.id
    return (
        <Item isActive={isActive} onClick={() => setActiveChannelId(channel.id)}>
            <div>{channel.display_name}</div>
            {channel.has_children && <div className="ss-navigateright" />}
        </Item>
    )
}

export const EditChannelListItem = ({ channel, isDisabled }: Props) => {
    const { openEditCollectionPanel } = useContext(ModalContext)
    return (
        <ActionItem onClick={() => openEditCollectionPanel(channel)} isDisabled={!!isDisabled}>
            <div>Edit Collection</div>
            <div className="ss-write" />
        </ActionItem>
    )
}

export const ViewChannelListItem = ({ channel, isDisabled }: Props) => {
    // wish we could history push here but channels use window id to know root, branch or leaf
    return (
        <ActionItem
            onClick={e => {
                if (e.metaKey) {
                    window.open(channel.url)
                } else {
                    location.href = channel.url
                }
            }}
            isDisabled={!!isDisabled}
        >
            <div>View Collection</div>
            <div className="ss-send" />
        </ActionItem>
    )
}

export const AddChannelListItem = ({ channel, isDisabled }: Props) => {
    const { openNewCollectionPanel } = useContext(ModalContext)
    const { channels } = useContext(CollectionContext)
    const depth = getChannelDepth(channel, channels)
    return depth < MAX_DEPTH ? (
        <ActionItem
            onClick={() => openNewCollectionPanel({ parentChannel: channel, userId: channel.user?.id })}
            isDisabled={!!isDisabled}
        >
            <div>Create New Collection</div>
            <div className="ss-plus" />
        </ActionItem>
    ) : null
}

export default ChannelListItem
